const eventHelper = (_node, listener, handler, add) => {
  if (Array.isArray(listener)) {
    if (add !== false) {
      listener.forEach(listener => {
        _node.addEventListener(listener, handler)
      })
    } else {
      listener.forEach(listener => {
        _node.removeEventListener(listener, handler)
      })
    }
  } else {
    if (add !== false) {
      _node.addEventListener(listener, handler)
    } else {
      _node.removeEventListener(listener, handler)
    }
  }
}

class DomNode {
  constructor(_node) {
    this._node = _node
  }

  hasClass(className) {
    return this._node.classList.contains(className)
  }

  addClass(className) {
    this._node.classList.add(className)
  }

  removeClass(className) {
    this._node.classList.remove(className)
  }

  on(listener, handler) {
    eventHelper(this._node, listener, handler)
  }

  off(listener, handler) {
    eventHelper(this._node, listener, handler, false)
  }

  click(handler, add) {
    if (add !== false) this._node.addEventListener('click', handler)
    else this._node.removeEventListener('click', handler)
  }

  ancestor(query, native) {
    if (!query) return (native) ? this._node.parentElement : new DomNode(this._node.parentElement)

    let node = this._node
    /* eslint-disable curly */
    while ((node = node.parentElement) && (!node.classList.contains(query.substring(1)) && node.id !== query.substring(1)))
    /* eslint-disable indent */
    return (native) ? node : new DomNode(node)
  }

  descendants(query, native) {
    if (!query) {
      let _list = {native: [], nodes: []}

      Array.from(this._node.children).forEach(node => {
        _list.native.push(node)
        _list.nodes.push(new DomNode(node))
      })

      return (native) ? _list.native : new DomList(_list)
    }

    let node = this._node.firstChild
    /* eslint-disable curly */
    while ((node = node.nextSibling || node.firstChild) && (!node.classList.contains(query.substring(1)) && node.id !== query.substring(1)))
    /* eslint-disable indent */
    return (native) ? node : new DomNode(node)
  }
}

class DomList {
  constructor(_list) {
    this.native = _list.native
    this._list = _list.nodes
  }

  addClass(className) {
    this._list.forEach(_node => {
      _node.addClass(className)
    })
  }

  removeClass(className) {
    this._list.forEach(_node => {
      _node.removeClass(className)
    })
  }

  on(listener, handler) {
    this._list.forEach(_node => {
      _node.on(listener, handler)
    })
  }

  off(listener, handler) {
    this._list.forEach(_node => {
      _node.off(listener, handler)
    })
  }

  click(handler, add) {
    this._list.forEach(_node => {
      _node.click(handler, add)
    })
  }
}

export default {
  node: query => {
    if (query instanceof Element) return new DomNode(query)

    let node = document.querySelector(query)
    return (!node) ? node : new DomNode(node)
  },

  list: query => {
    let _list = {native: [], nodes: []}

    Array.from(document.querySelectorAll(query)).forEach(node => {
      _list.native.push(node)
      _list.nodes.push(new DomNode(node))
    })

    return (!_list.native.length) ? _list.native : new DomList(_list)
  },

  on: function(listener, handler) {
    eventHelper(document, listener, handler)
  },

  off: function(listener, handler) {
    eventHelper(document, listener, handler, false)
  },

  scroll: function(handler, add = true) {
    if (add) window.addEventListener('scroll', handler)
    else window.removeEventListener('scroll', handler)
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/_dom.js